module.exports = vendors_ru_d22a8463d0e89e8bc20f;